export default "__VITE_ASSET__f7d72e61__"